import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'reviewsApi',
  baseQuery,
  tagTypes: ['reviews'],
  endpoints: builder => ({
    getList: builder.query({
      query: () => ({
        url: endpoints.REVIEWS,
        method: 'GET',
      }),
      providesTags: ['reviews'],
    }),
    updateReviewStatus: builder.mutation({
      query: (data: { review_id: number; status: number }) => ({
        url: endpoints.REVIEWS + '/update',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['reviews'],
    }),
  }),
});

export const { actions: reviewsAction } = slice;

export const useReviewsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: reviewsAction,
    useGetListQuery: api.useLazyGetListQuery,
    useUpdateReviewStatusMutation: api.useUpdateReviewStatusMutation,
  };
};
